var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.02 6L8.60999 7.41L13.19 12L8.60999 16.59L10.02 18L16.02 12L10.02 6Z",
    fill: "#2B6CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav);
export default __webpack_public_path__ + "static/media/icon_nav.2555bfef56395931335092d75e1d4ff6.svg";
export { ForwardRef as ReactComponent };